// src/components/analytics/PointsFlowChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const PointsFlowChart = ({ dateRange, selectedProgram, granularity }) => {
    // Mock data for points issued and redeemed
    const generateData = () => {
        const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
        const pointsIssued = [20000, 22000, 25000, 28000, 30000, 32000];
        const pointsRedeemed = [15000, 18000, 20000, 23000, 26000, 28000];

        return {
            labels: labels,
            datasets: [
                {
                    label: 'Points Issued',
                    data: pointsIssued,
                    backgroundColor: 'rgba(59, 130, 246, 0.8)', // Blue-500
                    borderColor: 'rgba(59, 130, 246, 1)',
                    borderWidth: 1,
                },
                {
                    label: 'Points Redeemed',
                    data: pointsRedeemed,
                    backgroundColor: 'rgba(239, 68, 68, 0.8)', // Red-500
                    borderColor: 'rgba(239, 68, 68, 1)',
                    borderWidth: 1,
                },
            ],
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: { family: 'Inter, sans-serif' },
                    color: '#374151',
                },
            },
            title: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: { family: 'Inter, sans-serif' },
                titleFont: { family: 'Inter, sans-serif', weight: 'bold' }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' }
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(209, 213, 219, 0.4)',
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' },
                    callback: function(value) {
                        return value.toLocaleString();
                    }
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Points Issued vs. Redeemed</h3>
            <p className="text-sm text-gray-500 mb-4">Track the flow of loyalty points.</p>
            <div className="flex-1 relative">
                <Bar data={generateData()} options={options} />
            </div>
        </div>
    );
};

export default PointsFlowChart;